import {
  BRAND_COLOR,
  LOGO_VIEWBOX,
  MARK_PATH,
  MARK_VIEWBOX,
  WORDMARK_PATH,
} from "@listou/shared/brand";
import { Link } from "@tanstack/react-router";

/** The gift with a heart, alone: where the name is already on screen or there is no room. */
export function LogoMark({ className = "size-9" }: { className?: string }) {
  return (
    <svg viewBox={MARK_VIEWBOX} className={className} aria-hidden>
      <path d={MARK_PATH} fill={BRAND_COLOR} />
    </svg>
  );
}

export function Logo({ to = "/" }: { to?: "/" | "/mes-listes" }) {
  return (
    <Link to={to} className="inline-flex items-center rounded-lg" aria-label="Listou, accueil">
      <svg viewBox={LOGO_VIEWBOX} className="h-8 w-auto" aria-hidden>
        <path d={`${MARK_PATH}${WORDMARK_PATH}`} fill={BRAND_COLOR} />
      </svg>
    </Link>
  );
}
